// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag--grey[data-v-b8108c4a]{background-color:var(--tw-auth-settings-tag-color)}", "",{"version":3,"sources":["webpack://./src/components/Tag.vue"],"names":[],"mappings":"AACA,4BACE,kDAAF","sourcesContent":["\r\n.tag--grey {\r\n  background-color: var(--tw-auth-settings-tag-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
